import { render, staticRenderFns } from "./filtrate.vue?vue&type=template&id=2a4a3add&scoped=true&"
import script from "./filtrate.vue?vue&type=script&lang=js&"
export * from "./filtrate.vue?vue&type=script&lang=js&"
import style0 from "./filtrate.vue?vue&type=style&index=0&id=2a4a3add&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a3add",
  null
  
)

export default component.exports